import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import history from '../routes/history';
import LoaderReducer from './Loader';
import CustomerReducer from './Customer';
import SelectReducer from './Select';
import Graphql from './Graphql';
import Theme from './Theme';
import SystemParameter from './SystemParameter';

export default combineReducers({
  router: connectRouter(history),
  loader: LoaderReducer,
  customer: CustomerReducer,
  select: SelectReducer,
  graphql: Graphql,
  theme: Theme,
  systemParameter: SystemParameter,
});
